import React from "react";

export default function StartScreen({ onStart }) {
  return (
    <div className="w-full h-screen bg-gray-900 flex items-center justify-center text-white">
      <div className="text-center">
        <h1 className="text-5xl font-bold mb-4">SORA MO YOU</h1>
        <p className="text-xl text-gray-300 mb-8">モードを選択</p>
        <div className="flex flex-col items-center gap-4">
          <div
            onClick={() => onStart(true)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") onStart(true);
            }}
            role="button"
            tabIndex="0"
            className="w-64 bg-transparent hover:bg-blue-500 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 cursor-pointer flex items-center justify-center border-2 border-blue-500"
          >
            SORA MO YOUモード
          </div>
          <div
            onClick={() => onStart(false)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") onStart(false);
            }}
            role="button"
            tabIndex="0"
            className="w-64 bg-transparent hover:bg-gray-500 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 cursor-pointer flex items-center justify-center border-2 border-gray-500"
          >
            通常運転モード
          </div>
        </div>
        <p className="text-sm text-gray-500 mt-8">
          音声再生にはユーザー操作が必要です
        </p>
      </div>
    </div>
  );
}
